import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";

import "./style.scss";

const RevenueShare = ({ handleUpdata, index, item }) => {
    const handleChangeValue = (value, key) => {
        handleUpdata(index, { ...item, [key]: value });
    };

    return (
        <div className="revenue-share">
            <div className="flex">
                <div className="block__input">
                    <label>Укажите процент от суммы*</label>
                    <InputNumber placeholder="0" suffix="%" min={0} max={100} onChange={(e) => handleChangeValue(e.value, "percentAmount")} />
                </div>
                <div className="block__input">
                    <label>Укажите средний чек*</label>
                    <InputNumber locale="ru-RU" placeholder="0" mode="currency" currency="RUB" onChange={(e) => handleChangeValue(e.value, "averageBill")} />
                </div>
            </div>

            <div className="block__input">
                <label>Опишите к чему привязана ставка* (это поможет найти нужную ставку при заведение оффера)</label>
                <InputText placeholder="Укажите комментарий" value={item.comments} onChange={(e) => handleChangeValue(e.target.value, "comments")} />
            </div>
        </div>
    );
};

export default RevenueShare;
